module.exports = __webpack_public_path__ + "img/8.573b390c.jpg";